import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../../firebase";
import { Policy } from "./policy.type";

export const PolicyApi = createApi({
  reducerPath: "policyApi",
  tagTypes: ["policy", "policies", "policyType", "ln"],
  baseQuery: fakeBaseQuery(),
  endpoints: (builder) => ({
    addOrEditPolicy: builder.mutation({
      async queryFn({ uid, ...data }) {
        try {
          if (!uid) {
            const docRef = await addDoc(collection(db, "policies"), data);
            return {
              data: {
                uid: docRef.id,
                message: "Contenu ajouté.",
                ...data,
              },
            };
          } else {
            // Mettre à jour Firestore
            const policyRef = doc(db, "policies", uid);
            await updateDoc(policyRef, data);

            return {
              data: {
                message:
                  "Contenu modifié.",
              },
            };
          }
        } catch (error: any) {
          return { error: { status: "CUSTOM", message: error.message } };
        }
      },
      invalidatesTags: ["policies", "policyType"],
    }),
    // 
    getPolicy: builder.query({
      queryFn: async (policyId) => {
        try {
          const policyRef = doc(db, "policies", policyId);
          const policySnap = await getDoc(policyRef);

          if (!policySnap.exists()) {
            return {
              error: { status: 404, message: "Item introuvable !" },
            };
          }

          return { data: { uid: policySnap.id, ...policySnap.data() } };
        } catch (error: any) {
          return { error: { status: 500, message: error.message } };
        }
      },
      providesTags: ["policyType"],
    }),
    // 
    getPolicies: builder.query({
      async queryFn() {
        try {
          return new Promise((resolve) => {
            const q = collection(db, "policies");
            onSnapshot(q, (snapshot) => {
              const policies = snapshot.docs.map((doc) => ({
                uid: doc.id,
                ...doc.data(),
              }));
              resolve({ data: policies as Policy[] });
            });
            // unsubscribe();
          });
        } catch (error) {
          return { error };
        }
      },
      keepUnusedDataFor: 0,
      async onCacheEntryAdded(
        arg,
        { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
      ) {
        const policiesRef = collection(db, "policies");
        let unsubscribe;
        try {
          await cacheDataLoaded;

          unsubscribe = onSnapshot(policiesRef, (snapshot) => {
            const policies = snapshot.docs.map((doc) => ({
              uid: doc.id,
              ...doc.data(),
            }));
            updateCachedData(() => policies);
          });
        } catch (error) {
          console.error("Erreur de souscription:", error);
        }

        // Nettoyer l'écouteur Firestore quand le cache est supprimé
        await cacheEntryRemoved;
        if (unsubscribe) unsubscribe();
      },
      providesTags: ["policies"],
    }),
  }),
});

export const {
  useAddOrEditPolicyMutation,
  useGetPoliciesQuery,
} = PolicyApi;
